
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 3h18a2 2 0 012 2v14a2 2 0 01-2 2H3a2 2 0 01-2-2V5a2 2 0 012-2zm3.5 12.1h1.21V9.39H6.5v5.71zm6.02-1.585c0-.373-.1-.687-.297-.944-.198-.256-.564-.512-1.098-.767-.404-.193-.66-.326-.768-.4a.816.816 0 01-.236-.231.517.517 0 01-.074-.28c0-.171.061-.31.183-.417.123-.107.299-.16.528-.16.193 0 .388.024.588.074.199.05.45.137.756.262l.39-.942a5.84 5.84 0 00-.846-.297 3.353 3.353 0 00-.85-.105c-.603 0-1.077.144-1.419.433-.342.29-.514.687-.514 1.192 0 .268.052.502.157.703.104.2.243.376.418.527.174.151.436.309.785.473.372.177.619.306.74.387.121.08.213.164.275.252a.5.5 0 01.094.298c0 .201-.07.352-.213.454-.142.101-.346.152-.611.152-.222 0-.466-.035-.733-.106a6.664 6.664 0 01-.978-.363v1.125c.469.23 1.008.344 1.617.344.662 0 1.178-.149 1.549-.445.371-.297.557-.704.557-1.22zm6.218-1.277c0-.948-.232-1.675-.697-2.18-.465-.505-1.136-.758-2.014-.758-.877 0-1.551.25-2.021.752-.47.501-.705 1.227-.705 2.178 0 .95.234 1.68.703 2.187.469.508 1.14.762 2.016.762.875 0 1.546-.254 2.015-.762.469-.508.703-1.234.703-2.18zm-4.168 0c0-.639.123-1.12.367-1.444.245-.324.609-.486 1.09-.486.961 0 1.442.643 1.442 1.93 0 1.283-.483 1.925-1.45 1.925-.481 0-.843-.161-1.085-.484-.243-.323-.364-.803-.364-1.441z"}})])
          )
        }
      }
    